export class OpenDirectoryEditingList {
   public static readonly type = '[DirectoryEditingList] Open Directory Editing List';
}

export class CloseDirectoryEditingList {
   public static readonly type = '[DirectoryEditingList] Close Directory Editing List';
}

export class ToggleDirectoryEditingList {
   public static readonly type = '[DirectoryEditingList] Toggle Directory Editing List';
}
